import React from 'react'
import { HashRouter, Switch, Route } from 'react-router-dom'
import AuthRoute from './authRoute'
import BasicLayout from '../components/BasicLayout/BasicLayout'
import Order from '../components/Order/Order'
import OrderDefined from '../components/Order/OrderDefined'
import OrderContentDetails from '../components/Order/OrderContentDetails'
import HistoricalOrders from '../components/HistoricalOrders/HistoricalOrders'
import OrderDetails from '../components/HistoricalOrders/OrderDetails'
import Index from '../components/Index/Index'
import Register from '../components/Register/Register'
import MeIndex from '../components/Me/MeIndex'
import BindPage from '../components/Me/BindPage'
import TipPage from '../components/Register/TipPage'
import ClearLocalStorage from './ClearLocalStorage'
import { ThemeContextProvider } from '../contexts/ThemeContext'
// import { Session } from '../contexts/Session'
export default function GetRoute (props) {
  // const SessionContext = useContext(Session)
  const routes = [
    { path: '/order', component: Order, auth: true },
    { path: '/order/orderDefined', component: OrderDefined, auth: true },
    { path: `/order/orderContentDetails/:id/:date/:mealType`, component: OrderContentDetails, auth: true },
    { path: '/historicalOrders', component: HistoricalOrders, auth: true },
    { path: '/historicalOrders/orderMsg/:id', component: OrderDetails, auth: true },
    { path: '/me', component: MeIndex, auth: true }
  ]

  // const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId')

  // if (!sdxPatPositionId) {
  //   if (JSON.stringify(SessionContext.positionInfo) !== '{}') {
  //     SessionContext.setPositionInfo({})
  //   }
  //   if (SessionContext.patientInfo.length !== 0) {
  //     SessionContext.setPatientInfo([])
  //   }
  // }

  return (
    <ThemeContextProvider>
      <HashRouter>
        <Switch>
          <Route exact path={'/register'} component={Register} />
          <Route exact path={'/bind'} component={BindPage} />
          <Route exact path={'/tipPage/:nextPage'} component={TipPage} />
          {/* <Route exact key={'/register'} path={'/register'} render={props => <AuthRoute item={{ path: '/register', item: Register }} props={props} />} />
          <Route exact key={'/bind'} path={'/bind'} render={props => <AuthRoute item={{ path: '/bind', item: BindPage }} props={props} />} />
          <Route exact key={'/tipPage'} path={'/tipPage/:nextPage'} render={props => <AuthRoute item={{ path: '/tipPage/:nextPage', item: TipPage }} props={props} />} /> */}
          <Route exact path={'/index/:hisCode/:patPositionId'} component={Index} />
          <Route exact path={'/index/:hisCode'} component={Index} />
          <Route exact path={'/clearLocalStorage'} component={ClearLocalStorage} />
          <BasicLayout>
            {routes.map((item) => {
              return <Route key={item.path} path={item.path} exact render={props => {
                if (!item.auth) {
                  return <item.component {...props} />
                } else {
                  return <AuthRoute item={item} props={props} />
                }
              }} />
            })}
          </BasicLayout>
        </Switch>
      </HashRouter>
    </ThemeContextProvider>
  )
}
